import { createAction, props } from '@ngrx/store';

import { BoardLayoutInspectionTemplatesUsage, RestBoardModel } from '@main-application/boards/interfaces/board';
import {
  BoardsSummaryStatsDetails,
  SummaryFilters,
  SummaryStatsGroup,
} from '@ui-components/components/summary-expandable-table/summary-expandable-table.model';

export const closeMenus = createAction('[Boards] close menus');

export const loadBoardList = createAction('[Boards] loadBoardList');
export const loadBoardListSuccess = createAction(
  '[Boards] loadBoardListSuccess',
  props<{ boards: RestBoardModel[] }>()
);
export const loadBoardListFailed = createAction('[Boards] loadBoardListFailed');

export const updateTemplateUsage = createAction(
  '[Boards] updateTemplateUsage',
  props<{ usage: BoardLayoutInspectionTemplatesUsage }>()
);

export const updateTemplateUsageSuccess = createAction('[Boards] updateTemplateUsageSuccess');
export const updateTemplateUsageFailed = createAction('[Boards] updateTemplateUsageFailed');

export const getTemplatesUsage = createAction('[Boards] getTemplatesUsage', props<{ id: number }>());

export const getTemplatesUsageSuccess = createAction(
  '[Boards] getTemplatesUsageSuccess',
  props<{ templatesUsage: BoardLayoutInspectionTemplatesUsage[] }>()
);

export const getTemplatesUsageFailed = createAction('[Boards] getTemplatesUsageFailed', props<{ error: any }>());

export const loadBoardSummaryStats = createAction(
  '[Boards] Load Board Summary Stats',
  props<{ filter: SummaryFilters }>()
);

export const loadBoardSummaryStatsSuccess = createAction(
  '[Boards] Load Board Summary Stats Success',
  props<{ stats: SummaryStatsGroup[] }>()
);

export const loadBoardSummaryStatsFailed = createAction(
  '[Boards] Load Board Summary Stats Failed',
  props<{ error: any }>()
);

export const loadBoardSummaryDetails = createAction(
  '[Boards] Load Board Summary Details',
  props<{ filter: SummaryFilters }>()
);

export const loadBoardSummaryDetailsSuccess = createAction(
  '[Boards] Load Board Summary Details Success',
  props<{ details: BoardsSummaryStatsDetails }>()
);

export const loadBoardSummaryDetailsFailed = createAction(
  '[Boards] Load Board Summary Details Failed',
  props<{ error: any }>()
);
